<template>
    <div class="row">

      <el-drawer title="" :visible.sync="showAssignLeader" direction="btt" :before-close="handleClose" size="90%"
        :destroy-on-close="true">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <voter-form @save="getVoters()" v-if="showForm" :voter="selected"></voter-form>
          </div>
        </div>
      </el-drawer>


      <el-drawer title="" :visible.sync="showForm" direction="btt" :before-close="handleClose" size="90%"
        :destroy-on-close="true">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <voter-form @save="getVoters()" v-if="showForm" :voter="selected"></voter-form>
          </div>
        </div>
      </el-drawer>
  
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="category">Manage Voters</div>
        </div>
        <div class="card-body row">
          <div class="col-sm-6">
            <el-select class="select-default" v-model="pagination.perPage" placeholder="Per page" size="small">
              <el-option class="select-default" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <el-select class="select-default" v-model="barangay_id" placeholder="Select Barangay" size="small">
              <el-option class="select-default" v-for="barangay in barangays" :key="barangay.id" :label="barangay.name" :value="barangay.id">
              </el-option>
            </el-select>
            <el-select class="select-default" v-model="position" placeholder="Position" size="small">
              <el-option class="select-default" label="All Members/Leaders" :value="null">
              </el-option>
              <el-option class="select-default" label="Members" value="member">
              </el-option>
              <el-option class="select-default" label="Leaders" value="leader">
              </el-option>
              <el-option class="select-default" label="Members w/ no Leader" value="member_no_leader">
              </el-option>
              <el-option class="select-default" label="Leaders w/ no member" value="leader_no_member">
              </el-option>
            </el-select>
            <el-button type="primary" size="small" class="ml-2" @click="handleForm">New +</el-button>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input class="input-sm" placeholder="Search" v-model="term" addon-right-icon="nc-icon nc-zoom-split">
              </fg-input>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table class="table-striped" header-row-class-name="text-primary" :data="voters" style="width: 100%">  
              <el-table-column :min-width="120" 
               class-name="td-actions" label="Name">
                <template slot-scope="props">
                  {{ props.row.full_name }}<br>
                  <div>COMELEC ID: {{ props.row.comelec_id }}</div>
                  <div>PRECINT NO: {{ props.row.precint_number }}</div>
                  <div>CODE:
                    <div>{{ props.row.code }}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column :min-width="100" 
               class-name="td-actions bold" label="Type">
                <template slot-scope="props">
                  <div v-if="props.row.is_leader" class="text-primary">LEADER</div>
                  <div v-if="!props.row.is_leader" class="text-warning">MEMBER</div>
                  <div v-if="props.row.is_leader" class="text-info">{{ props.row.members_count }} {{ props.row.members_count > 1 ? 'MEMBERS':'MEMBER' }}</div>
                  <div v-if="!props.row.is_leader" class="text-info">LEAD BY {{ props.row.leader ? props.row.leader.full_name : 'None'}}</div>
                </template>
              </el-table-column>

              <el-table-column :min-width="120" 
               class-name="td-actions" label="Address">
                <template slot-scope="props">
                  <div v-if="props.row.barangay">{{ props.row.barangay.name }}</div>
                  Purok: {{ props.row.purok }}
                  <div>{{ props.row.full_address }}</div>
                </template>
              </el-table-column>

              <el-table-column :min-width="120" 
               class-name="td-actions" label="Contact Info">
                <template slot-scope="props">
                  <div>Birth Date: {{ props.row.birth_date }}</div>
                  <div>Phone: {{ props.row.contact_number }}</div>
                  <div>Email: {{ props.row.email }}</div>
                </template>
              </el-table-column>
              
              <el-table-column :min-width="120" 
               class-name="td-actions" label="Actions">
                <template slot-scope="props">
                  <div>
                    <el-button type="default" link @click="handleLeader(props.row)" size="mini" v-if="!props.row.is_leader">
                    Mark as Leader
                  </el-button>
                  </div>
                  <div>
                    <el-button type="default" link @click="handleLeader(props.row, 'mark_as_member')" size="mini" v-if="props.row.is_leader">
                    Mark as member
                  </el-button>
                  </div>
                  <el-button type="default" link @click="handleEdit(props.row)" size="mini">
                    <i class="fa fa-edit"></i>
                  </el-button>
                  <confirm-delete @onClick="handleDelete(props.row)" :label="''"></confirm-delete>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Found {{ pagination.total }} data</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
              :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  
  import { Barangay } from '@/resources/barangay'

  import { Voter } from '@/resources/voter'
  import ConfirmDelete from '../../Common/ConfirmDelete.vue'
import VoterForm from './VoterForm.vue'
  
  export default {
    components: { ConfirmDelete, VoterForm },
    data() {
        return {
        loading: false,
        showForm: false,
        voters: [],
        selected: null,
        perPageOptions: [5, 10, 15],
        pagination: {
          perPage: 10,
          currentPage: 1,
          total: 0
        },
        term: null,
        barangays: [],
        barangay_id: null,
        position: null,
        showAssignLeader: false
      }
    },
    watch: {
      term: function () {
        if (!this.term || this.term.length > 2) {
          this.getVoters()
        }
      },
      'pagination.perPage': function () {
        if (this.pagination.currentPage == 1) {
          this.getVoters()
        } else {
          this.pagination.currentPage = 1
        }
      },
      'pagination.currentPage': function () {
        this.getVoters()
      },
      barangay_id: function () {
        this.getVoters()
      },
      position: function () {
        this.getVoters()
      }
    },
    created: function () {
      this.getBarangays()
      this.getVoters()
    },
    methods: {
      handleAssignLeader(model) {
        this.showAssignLeader = true
        this.selected = Object.assign({}, model)
      },
      handleLeader(model, option){
        this.loading = true
        Voter.update(model.id, {option: option || 'mark_as_leader'})
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Voter has been marked as leader',
            });
            this.getVoters()
          })
          .catch(() => {
  
          }).finally(() => {
            this.loading = false
          })
      },
      handleEdit(model) {
        this.showForm = true
        this.selected = Object.assign({}, model)
      },
      handleClose() {
        this.showDelete = false
        this.showForm = false
        this.showAssignLeader = false
      },
      handleForm() {
        this.showForm = true
        this.selected = null
      },
      handleDelete(model) {
        this.loading = true
  
        Voter.delete({ id: model.id })
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Voter has been removed',
            });
            this.getVoters()
          })
          .catch(() => {
  
          }).finally(() => {
            this.loading = false
          })
      },
      getVoters() {
        this.handleClose()
        let params = { term: this.term, position: this.position, page: this.pagination.currentPage, per_page: this.pagination.perPage, barangay_id: this.barangay_id }
        this.loading = true
        Voter.get(params)
          .then(result => {
            this.pagination = result.data.meta
            if (result.data.voters)
              this.voters = result.data.voters
          })
          .catch(() => {
            this.$notify({
              type: 'danger',
              title: "Error",
              text: 'Unable to fetch voters',
            });
  
          }).finally(() => {
            this.loading = false
          })
      },
      getBarangays() {
        let params = {  page: 1, per_page: 99999 }
        this.loading = true
        Barangay.get(params)
          .then(result => {
            if (result.data.barangays)
              this.barangays = result.data.barangays
          })
          .catch(() => {
            this.$notify({
              type: 'danger',
              title: "Error",
              text: 'Unable to fetch barangays',
            });
  
          }).finally(() => {
            this.loading = false
          })
      }
    }
  }
  </script>
  <style lang="scss"></style>
  